import React from 'react'

import {
  AlignItems,
  Body3,
  Box,
  Color,
  Display,
  FlexDirection,
  FontFamily,
  Icon,
  JustifyContent,
  Text,
  withCitrusTheme,
} from '@gousto-internal/citrus-react'

import type { NextBoxOfferData } from '@library/api-customer-engagement-experience'

const OfferBannerSurface = withCitrusTheme(Box, () => ({
  borderRadius: '8px',
}))

export const OfferBanner = ({ offer }: { offer: NextBoxOfferData }) => (
  <OfferBannerSurface
    data-testid="next-box-offer-banner"
    display={Display.Flex}
    flexDirection={[FlexDirection.Column, FlexDirection.Row, FlexDirection.Row, FlexDirection.Row]}
    justifyContent={JustifyContent.SpaceBetween}
    alignItems={[null, AlignItems.Center, AlignItems.Center, AlignItems.Center]}
    gap={2}
    bg={Color.Success_50}
    paddingV={[2, 4, 4, 4]}
    paddingH={4}
  >
    <Box display={Display.Flex} flexDirection={FlexDirection.Column} gap={1}>
      <Text size={[7, 9, 9, 9]} fontFamily={FontFamily.Bold} color={Color.ColdGrey_800}>
        {offer.badge}
      </Text>
    </Box>
    {offer.expiry_label && (
      <Box display={Display.Flex} alignItems={AlignItems.Center} gap={1}>
        <Icon name="time" size={4} />
        <Body3 size={2} color={Color.ColdGrey_700}>
          {offer.expiry_label}
        </Body3>
      </Box>
    )}
  </OfferBannerSurface>
)
